import { ChangeEvent, useMemo } from "react";
import { Checkbox } from "@mui/material";
import { AdminLeadListResDto } from "service/api/estabrookSchemas";
import { LabelValueItem } from "@/shared/components/table/GenericTable";
import { FilterState } from "./useLeadsFilters";

const useLeadsTableHeader = (
  filters: FilterState,
  data: AdminLeadListResDto[],
  handleSelectAll: (evt: ChangeEvent<HTMLInputElement>) => void,
) => {
  const allIds = data.map((lead) => lead.id);
  // Check that every id on this page is actually selected — not just a count
  // match, which could show "checked" from a stale selection on another page.
  const isAllSelected =
    allIds.length > 0 &&
    allIds.every((id) => filters.selectedLeadIds.includes(id));

  return useMemo<LabelValueItem[]>(
    () => [
      {
        label: <Checkbox checked={isAllSelected} onChange={handleSelectAll} />,
        value: "checkbox",
        size: "4%",
        sortable: false,
      },
      {
        label: "Lead",
        value: "lead",
        size: "22%",
        minWidth: "200px",
        sortable: true,
        // The "Lead" cell shows name + email, but sorts by name.
        sortableValue: "fullName",
      },
      {
        label: "Address",
        value: "address",
        size: "22%",
        minWidth: "200px",
        sortable: true,
      },
      {
        label: "Phone",
        value: "phoneNumber",
        size: "13%",
        minWidth: "130px",
        sortable: true,
      },
      {
        label: "Date Created",
        value: "createdAt",
        size: "13%",
        minWidth: "130px",
        sortable: true,
      },
      // Always-visible state button: Convert to Customer.
      { label: "", value: "state", size: "20%", minWidth: "160px" },
      // Hover edit / delete.
      { label: "", value: "actions", size: "6%", minWidth: "80px" },
    ],
    // isAllSelected / handleSelectAll derive from selection + data.
    [filters.selectedLeadIds, data],
  );
};

export default useLeadsTableHeader;
